import { call, put, takeLatest } from "redux-saga/effects";
import { rejectDraftService, markValidatedService } from "api/services/validateService";
import * as types from "redux/reducers/service/actionTypes";
import { SET_MESSAGES_REDUCER } from "redux/reducers/messages/actionTypes";
import { SORT, DIRECTION, LIMIT, SKIP } from "common/utils";

const refreshValidateListParams = {
  sort: SORT,
  direction: DIRECTION,
  limit: LIMIT,
  skip: SKIP,
  isShowAll: true,
  filter: "hasDraft",
  hasDraft: true,
};

function* fRejectDraftService(action) {
  try {
    const { id } = action;
    yield call(rejectDraftService, id);
    yield put({
      type: SET_MESSAGES_REDUCER,
      message: {
        type: "success",
        key: "REJECT_SUCCESSFULLY",
        message: "Rejected successfully.",
      },
    });
    yield put({
      type: types.GET_SERVICES_REDUCER,
      params: refreshValidateListParams,
      pageSize: LIMIT,
      defaultQuery: true,
    });
  } catch (error) {
    const err = error as any;
    yield put({
      type: SET_MESSAGES_REDUCER,
      message: {
        type: "error",
        key: "REJECT_ERROR",
        message: (err && err.response && err.response.data && err.response.data.message) || "Failed to reject draft.",
      },
    });
  } finally {
    yield put({ type: types.SET_VALIDATING_SERVICE_ID, id: null });
  }
}

function* fMarkValidatedService(action) {
  try {
    const { id } = action;
    yield call(markValidatedService, id);
    yield put({
      type: SET_MESSAGES_REDUCER,
      message: {
        type: "success",
        key: "VALIDATE_SERVICE_SUCCESSFULLY",
        message: "Service validated successfully",
      },
    });
    yield put({
      type: types.GET_SERVICES_REDUCER,
      params: refreshValidateListParams,
      pageSize: LIMIT,
      defaultQuery: true,
    });
  } catch (error) {
    const err = error as any;
    yield put({
      type: SET_MESSAGES_REDUCER,
      message: {
        type: "error",
        key: "MARK_VALIDATED_ERROR",
        message: (err && err.response && err.response.data && err.response.data.message) || "Failed to mark as validated.",
      },
    });
  } finally {
    yield put({ type: types.SET_VALIDATING_SERVICE_ID, id: null });
  }
}

function* ValidateService() {
  yield takeLatest(types.REJECT_DRAFT_SERVICE_REQUEST, fRejectDraftService);
  yield takeLatest(types.MARK_VALIDATED_SERVICE_REQUEST, fMarkValidatedService);
}

export default ValidateService;
